import e from"./Menu.vue_vue&type=script&lang.js";import{render as t}from"./Menu.vue_vue&type=template&id=524bff96&lang.js";e.render=t;export default e;
//# sourceMappingURL=Menu.vue.js.map
